import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {Session} from "../../services/session.service";
import {ActivatedRoute, Router} from "@angular/router";

const APP_URL = "https://app.seedit.com.gh";

export class SComponent implements OnInit{
  loggedIn: boolean;

  ngOnInit() {
    Session.headerObserver.next(true);
    Session.loggedInObserver.subscribe(loggedIn => {
      this.loggedIn = loggedIn;
      console.log(`subscription...${loggedIn}`)
    });
  }

  public getStarted(){
    window.open(APP_URL, "_self")
  }

  public startCampaign(){
    window.open(APP_URL + "/campaigns", "_self")
  }

  public startGroups(){
    window.open(APP_URL + "/groups", "_self")
  }
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class HeaderComponent extends SComponent {
  private showHeader: boolean;

  constructor() {
    super();
  }

  ngOnInit(){
    super.ngOnInit();

    Session.headerObserver.subscribe(show => this.showHeader = show);
  }

}





// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/header/header.component.ts